import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
// 导入 Element UI 语言包
import elementEn from 'element-ui/lib/locale/lang/en'; // ✅正确
import elementZhCN from 'element-ui/lib/locale/lang/zh-CN'; // ✅正确
import elementZhHK from 'element-ui/lib/locale/lang/zh-TW'; // ✅正确
import elementTh from 'element-ui/lib/locale/lang/th'; // 引入泰文语言包
import elementId from 'element-ui/lib/locale/lang/id';
import elementEs from 'element-ui/lib/locale/lang/es';
import elementVi from 'element-ui/lib/locale/lang/vi';
import enUS from '../locales/en-US.js';
import zhCN from '../locales/zh-CN.js';
import zhHK from '../locales/zh-HK.js';
import thTH from '../locales/th-TH.js';
import idID from '../locales/id-ID.js';
import esES from '../locales/es-ES.js';
import vi from '../locales/vi.js';
Vue.use(VueI18n);

const i18n = new VueI18n({
  // 默认语言可以写个固定值，后续在 main.js 中更新
  locale: Cookies.get('language') || 'zh-CN',
  messages: {
    'en-US': {
      ...enUS,
      ...elementEn, // 合并 Element UI 语言包
    },
    'zh-CN': {
      ...zhCN,
      ...elementZhCN, // 合并 Element UI 语言包
    },
    //繁体暂时使用简体，等整体搞完再生成
    'zh-HK': {
      ...zhHK,
      ...elementZhHK, // 合并 Element UI 语言包
    },
    'th-TH': {
      ...thTH,
      ...elementTh, // 合并 Element UI 语言包
    },
    'id-ID': {
      ...idID,
      ...elementId, // 合并 Element UI 语言包
    },
    'es-ES': {
      ...esES,
      ...elementEs, // 合并 Element UI 语言包
    },
    'vi-VN': {
      ...vi,
      ...elementVi, // 合并 Element UI 语言包
    },
  },
});

export default i18n;
